import React, { useEffect } from 'react';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import routes from './Config/routes';
import { BrowserRouter as Router, Route, Routes as Switch, useLocation } from 'react-router-dom';
import Schiff from './Pages/Schiff';
import Reisebericht from './Pages/Reisebericht';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

// const basename = document.querySelector('base')?.getAttribute('href') ?? '/aida-react';
const App = () => (
    // FIXME: TODO: Basename wieder entnehmen, wenn es auf den echten Webserver geht. Ebenso die Homepage in der package.json
    // <Router basename={basename}>
    <Router>
        <ScrollToTop />
        <div className="dark:stars pointer-events-none"></div>
        <a href='#main-content' className='hidden sm:block absolute text-aida-red bg-white shadow-md z-50 top-24 p-2 rounded-r-md -translate-x-full focus:translate-x-0 outline-aida-red'>skip to main content</a>
        <Header />
        <main id='main-content' className='flex-1 max-w-5xl mx-auto px-4 mb-48 w-full mt-32 md:mt-4'>
            <Switch>
                {routes.map(route => {
                    return <Route
                    key={route.path}
                        path={route.path}
                        element={route.component}
                        exact
                        />
                    })
                }
                <Route path={'/Schiff/:id'} element={<Schiff />} />
                <Route path={'/reiseberichte/:id/:slug'} element={<Reisebericht />} />
            </Switch>
        </main>
        <Footer />
    </Router>
);

export default App;
